// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 19) return "static/js/655ef6cf5c30debb53b3.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"0d98489a16eeede9a260","119":"340edb6d3bca50600b41","120":"08ff0c55f60e463adf3c"}[chunkId] + ".chunk.js";
};